import { useEffect, useState } from 'react';
import { db, auth, functions } from '../FirebaseAuthConfig.js';
import { doc, onSnapshot, getDoc } from 'firebase/firestore';
import { httpsCallable } from 'firebase/functions';

import ProfileBlock from '../Blocks/profileBlock.js';
import HeaderBlock from '../Blocks/headerBlock.js';
import LoggingBlock from '../Blocks/loggingBlock.js';
import ProgressBlock from '../Blocks/progressBlock.js';
import LeaderboardBlock from '../Blocks/leaderboardBlock.js';
import ResourcesBlock from '../Blocks/resourcesBlock.js';
import MedalBlock from '../Blocks/medalBlock.js';
import ActivityBlock from '../Blocks/activityBlock.js';
import AnnouncementBlock from '../Blocks/announcementBlock.js';
import TeamBlock from '../Blocks/teamBlock.js';
import IndividualBlock from '../Blocks/individualBlock.js';

import Loader from './loader.js';

// =====================================================================
// ADMIN-ONLY MODE - DELETE THIS ENTIRE BLOCK WHEN CHALLENGE GOES LIVE
// =====================================================================
// const ADMIN_ONLY_MODE = true; // Set to false or delete this block to allow all users
// =====================================================================

// SVG Paths for profile button icons
const SVG_PATH_PERSON =
    'M43.837,259.2l171.498,0c24.161,0 35.98,-8.046 35.98,-25.168c0,-39.581 -48.931,-88.165 -121.73,-88.165c-72.687,0 -121.701,48.584 -121.701,88.165c-0,17.122 11.873,25.168 35.952,25.168Zm-1.603,-26.377c-3.463,0 -4.669,-1.131 -4.669,-3.673c0,-20.15 33.535,-56.906 92.021,-56.906c58.514,0 92.051,36.756 92.051,56.906c0,2.542 -1.206,3.673 -4.7,3.673l-174.703,0Zm87.41,-102.246c33.837,0 60.851,-29.442 60.851,-65.98c0,-35.709 -27.247,-64.598 -60.851,-64.598c-33.437,0 -60.822,29.167 -60.822,64.764c0,36.455 27.096,65.814 60.822,65.814Zm0,-26.294c-18.315,0 -33.697,-16.666 -33.697,-39.584c0,-21.931 15.41,-38.323 33.697,-38.323c18.404,0 33.726,16.197 33.726,38.221c0,22.854 -15.18,39.686 -33.726,39.686Z';
const SVG_PATH_CLOSE =
    'M6.028,253.107c8.221,8.125 22.165,7.905 29.882,0.221l93.668,-93.798l93.651,93.724c7.881,7.978 21.627,7.905 29.786,-0.221c8.126,-8.254 8.199,-21.904 0.222,-29.82l-93.651,-93.691l93.651,-93.521c7.977,-8.012 8,-21.757 -0.222,-29.882c-8.254,-8.063 -21.904,-8.136 -29.786,-0.221l-93.651,93.617l-93.668,-93.691c-7.717,-7.622 -21.757,-7.938 -29.882,0.221c-8.063,8.221 -7.842,22.165 -0.221,29.882l93.764,93.595l-93.764,93.764c-7.622,7.622 -7.938,21.661 0.221,29.82Z';

// import ConfettiGenerator from 'confetti-js';

let currentDate = new Date().toLocaleDateString('en-us', { weekday: 'long', month: 'long', day: 'numeric' });

function Home() {
    const [currentAuthUser, setCurrentAuthUser] = useState(null);
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [profileSelected, setProfileSelected] = useState(false);

    useEffect(() => {
        let unsubscribe = auth.onAuthStateChanged(async (currentUser) => {
            if (currentUser) {
                // =====================================================================
                // ADMIN-ONLY CHECK - DELETE THIS BLOCK WHEN CHALLENGE GOES LIVE
                // =====================================================================
                // if (ADMIN_ONLY_MODE) {
                //     try {
                //         const userDoc = await getDoc(doc(db, `userCollection/${currentUser.uid}`));
                //         if (!userDoc.exists() || userDoc.data().isAdmin !== true) {
                //             // Not an admin, redirect to auth page
                //             window.location.replace('/auth');
                //             return;
                //         }
                //     } catch (error) {
                //         console.error('Error checking admin status:', error);
                //         window.location.replace('/auth');
                //         return;
                //     }
                // }
                // =====================================================================

                setCurrentAuthUser(currentUser);

                const checkUser = httpsCallable(functions, 'checkForUser');
                checkUser().then((response) => {
                    var resultData = response.data;

                    if (resultData.result === 'userExists - ISregistered') {
                        return;
                    } else {
                        auth.signOut();
                    }
                });
            } else {
                console.log('No logged in user found. Redirecting.');

                window.location.replace('/auth');
            }
        });
        return () => {
            unsubscribe();
        };
    }, []);

    useEffect(() => {
        // console.log("user changed ", currentAuthUser);
        if (!currentAuthUser) {
            return;
        }

        // console.log("here")
        const getUserData = onSnapshot(
            doc(db, 'userCollection', currentAuthUser.uid),
            (snapshot) => {
                console.log('getting data');
                setData(snapshot.data());
                setIsLoading(false);
            },
            (err) => {
                console.log(`Encountered Error: ${err}`);
            },
        );

        return () => {
            getUserData();
        };
    }, [currentAuthUser]);

    // useEffect(() => {
    //     var confettiSettings = {};

    //     if (window.innerWidth >= 640) {
    //         confettiSettings = {
    //             target: 'confetti-canvas',
    //             max: 90,
    //             size: 1.25,
    //             animate: true,
    //             respawn: true,
    //             clock: 20,
    //             rotate: true,
    //         };
    //     } else if (window.innerWidth <= 639) {
    //         confettiSettings = {
    //             target: 'confetti-canvas',
    //             max: 45,
    //             size: 0.75,
    //             animate: true,
    //             respawn: true,
    //             clock: 15,
    //             rotate: true,
    //         };
    //     }

    //     const confetti = new ConfettiGenerator(confettiSettings);
    //     confetti.render();

    //     return () => confetti.clear();
    // }, []);

    return (
        <div className="w-full h-fit min-h-screen bg-white dark:bg-neutral-800 flex flex-col justify-start items-center">
            <canvas className="fixed top-0 left-0 z-[999] pointer-events-none" id="confetti-canvas"></canvas>
            <div className="w-full h-fit flex flex-col justify-start items-center">
                {/* HEADER */}
                <div className="w-full h-16 grid grid-cols-3 justify-items-end items-center px-2.5 border-b border-neutral-200 dark:border-neutral-700">
                    <div />
                    <div className="h-12 aspect-square place-self-center">
                        <svg viewBox="0 0 1080 1080" className="fill-current text-[#FF671F] dark:text-white">
                            <path d="M537.245,190.102l542.755,699.796l-542.755,0l137.755,-179.082l-137.755,-170.816l-261.735,348.534l-275.51,0l537.245,-698.432Z" />
                            <path d="M473.878,889.898l129.49,-179.082l-66.122,-66.122l-187.347,245.204l123.98,0Z" />
                        </svg>
                    </div>
                    <div className="w-fit flex flex-row justify-center items-center">
                        {data.firstName !== '' ? (
                            <h5 className="text-sm/tight text-end text-neutral-700 dark:text-neutral-200 mr-3 font-light hidden md:block">
                                Welcome back,
                                <br />
                                <span className="text-black dark:text-white font-bold text-base">{data.firstName}</span>
                            </h5>
                        ) : (
                            <h5 className="text-sm/tight text-end text-neutral-700 dark:text-neutral-200 mr-3 font-light hidden md:block">Welcome</h5>
                        )}
                        {profileSelected === true ? (
                            <button
                                className="w-10 h-10 border-none rounded-full flex justify-center items-center bg-[#E0E0E0] dark:bg-neutral-600 transition-colors duration-350 ease-in-out cursor-pointer"
                                onClick={() => setProfileSelected(false)}
                            >
                                <svg viewBox="0 0 260 260" className="w-5 h-5 fill-current text-neutral-600 dark:text-neutral-300">
                                    <path d={SVG_PATH_CLOSE} />
                                </svg>
                            </button>
                        ) : null}
                        {profileSelected === false ? (
                            <button
                                className="w-10 h-10 border-none rounded-full flex justify-center items-center bg-[#E0E0E0] dark:bg-neutral-600 transition-colors duration-350 ease-in-out cursor-pointer overflow-hidden"
                                onClick={() => setProfileSelected(true)}
                            >
                                {data.profilePic !== '' ? (
                                    <img
                                        className="w-full h-full rounded-full object-cover"
                                        referrerPolicy="no-referrer"
                                        src={data.profilePic}
                                        alt="profileImg"
                                    />
                                ) : (
                                    <svg viewBox="0 0 260 260" className="w-6 h-6 fill-current text-neutral-600 dark:text-neutral-300">
                                        <path d={SVG_PATH_PERSON} />
                                    </svg>
                                )}
                            </button>
                        ) : null}
                    </div>
                </div>
                <div className="w-full max-w-[640px] sm:max-w-[768px] md:max-w-[1024px] lg:max-w-[1280px] xl:max-w-[1536px] my-4 flex flex-col justify-start items-center">
                    {profileSelected === true ? (
                        <div className="max-w-[56rem] mx-auto flex flex-col">
                            <ProfileBlock />
                        </div>
                    ) : null}
                    {profileSelected === false ? (
                        <div className="w-[90vw] md:w-[56rem] grid grid-cols-1 md:grid-cols-2 gap-4">
                            {/* HEADER - Full Width */}
                            <HeaderBlock className="col-span-1 md:col-span-2" />

                            {/* LEFT COLUMN: Logging */}
                            {/* <div className="col-span-1 flex flex-col gap-4">
                                <LoggingBlock />
                            </div> */}

                            {/* RIGHT COLUMN: Progress + Leaderboard */}
                            <div className="col-span-1 md:col-span-2 grid grid-cols-1 md:grid-cols-2 gap-4">
                                <ProgressBlock />
                                <LeaderboardBlock className="flex-1" />
                            </div>

                            {/* FULL WIDTH: Activity (2/3) & Resources (1/3) */}
                            <div className="col-span-1 md:col-span-2 grid grid-cols-1 md:grid-cols-3 gap-4">
                                <ActivityBlock className="order-2 md:order-none col-span-1 md:col-span-2" />
                                <ResourcesBlock className="order-1 md:order-none col-span-1" />
                            </div>
                        </div>
                    ) : null}
                </div>
            </div>
            {isLoading === true ? <Loader /> : null}
        </div>
    );
}

export default Home;
